import { Injectable } from '@angular/core';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WorkShift } from '../types/work-shift';
import {API_ENDPOINTS} from '../../../core/providers/constants/api.constants';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteWorkShiftService extends IApiBackendRouteService {
  constructor(
    protected readonly http: HttpClient,
  ) {
    super();
  }

  urlRoute = `${API_ENDPOINTS.SHIFTS}`;

  updateWorkShift(id: number): Observable<any> {
    return this.http.patch(`${this.urlRoute}/${id}/active`, null);
  }

  currentShiftDepartment(departmentId: number): Observable<WorkShift> {
    return this.http.get<WorkShift>(`${this.urlRoute}/${departmentId}/active`);
  }

  all(department: string = ''): Observable<WorkShift[]> {
    const queryParams = department ? `?department=${department}` : '';
    return this.http.get<WorkShift[]>(`${this.urlRoute}${queryParams}`);
  }
}
